module.exports = __webpack_public_path__ + "static/img/3_5_1.096d91fa.jpg";